import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import MessagingAttachment from '../../model/messagingAttachment.model';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {switchMap} from 'rxjs/operators';
import MessagingAccount from '../../model/messagingAccount.model';
import arrayBufferToBase64 from '../../app/util/arrayBufferToBase64';

@Injectable()
export default class MessagingAttachmentService {
    public constructor(private http: HttpClient) {
    }

    public download(attachment: MessagingAttachment, account: MessagingAccount): Observable<Blob> {
        return this.http.get<Blob>(environment.apiUrl + '/messaging/attachments/' + attachment.id + '/download' + '?account=' + account.id, {
            observe: 'response',
            responseType: 'arraybuffer' as 'json'
        }).pipe(switchMap((result: any) => {
            const blob = new Blob([result.body], { type: attachment.contentType });
            return of(blob);
        }));
    }

    public getContent(attachment: MessagingAttachment, account: MessagingAccount) {
        return this.http.get<Blob>(environment.apiUrl + '/messaging/attachments/' + attachment.id + '/download' + '?account=' + account.id, {
            observe: 'response',
            responseType: 'arraybuffer' as 'json'
        }).pipe(switchMap((result: any) => {
            let r = arrayBufferToBase64(result.body);
            return of(r);
        }));
    }
}
